import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import { useAuth } from '@/context/AuthContext';
import theme from '@/constants/theme';

const img = require('@/assets/images/img-login.png');

export default function WelcomeScreen() {
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate('/');
    }
  }, [token, navigate]);

  const handleLogin = () => {
    navigate('/login');
  };

  const handleRegister = () => {
    navigate('/register');
  };

  //   const handleForgotPassword = () => {
  //     navigate("/forgot-password");
  //   };

  return (
    <div style={styles.background}>
      <div style={styles.overlay}>
        <figure>
          <img src={require('@/assets/images/light-logo.png')} alt="Nawamethod logo" style={styles.logo} />
        </figure>
        <h1 style={styles.title}>Toma control de tu salud mental y emocional</h1>
        <p style={styles.subtitle}>
          A través de rutas personalizadas con videos cortos y ejercicios diarios.
        </p>
        <div style={styles.buttonContainer}>
          <button style={styles.loginButton} onClick={handleLogin}>
            <span style={styles.buttonText}>Iniciar Sesión</span>
          </button>
          <div style={styles.registerButton} onClick={handleRegister}>
            <span style={styles.registerButtonText}>Registrarme</span>
          </div>
        </div>
        <Link to="/forgot-password" style={styles.forgotPasswordText}>
          ¿Olvidaste tu contraseña?
        </Link>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  background: {
    backgroundImage: `url(${img})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100vh',
    width: '100vw',
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    height: '100%',
    width: '100%',
    display: 'flex',
    gap: 16,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
    boxSizing: 'border-box',
  },
  title: {
    fontSize: 28,
    color: theme.colors.text.default,
    textAlign: 'center',
    marginBottom: 12,
    fontWeight: 'bold',
    lineHeight: '34px',
    maxWidth: 400,
    textShadow: '0 0 20px #000',
  },
  subtitle: {
    fontSize: 16,
    color: theme.colors.text.body,
    textAlign: 'center',
    marginBottom: 24,
    maxWidth: 400,
    textShadow: '0 0 20px #000',
  },
  buttonContainer: {
    margin: '0 24px',
    width: '100%',
    maxWidth: 320,
  },
  loginButton: {
    backgroundColor: '#fff',
    padding: '12px 24px',
    borderRadius: 8,
    marginBottom: 12,
    border: 'none',
    width: '100%',
    cursor: 'pointer',
  },
  registerButton: {
    padding: '12px 24px',
    borderRadius: 8,
    background: 'linear-gradient(90deg, #0B7189, #080F5E)',
    color: '#FFFFFF',
    textAlign: 'center',
    cursor: 'pointer',
  },
  registerButtonText: {
    color: '#FFFFFF',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 14,
  },
  buttonText: {
    fontSize: 14,
    color: '#000',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  forgotPasswordButton: {
    marginTop: 16,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
  forgotPasswordText: {
    color: '#fff',
    textAlign: 'center',
    textDecoration: 'underline',
    fontSize: 14,
    fontWeight: 'bold',
  },
  logo: {
    maxWidth: 400,
    width: '100%',
    objectPosition: '20px 4px',
  },
};
